import { type ApiResponse, ApiFactory } from '@/utils/api'
import { Timezone } from '@/constants/enums/api/timeZone.enum'

export class TimeZoneService extends ApiFactory {
  constructor() {
    super('')
  }

  /** 設定使用者時區 */
  setUserTimezone = async (params: { timeZoneId: string }): Promise<ApiResponse> => {
    return await this.put<unknown, ApiResponse>(Timezone.userInfoTimezone, params)
  }
}
